<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>fa-pound-sign</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Funding Offered</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card flat tile class="ma-0 mb-5">
        <v-card-text>
          <v-form lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout>
                <v-flex xs12 sm6 md6 class="pa-3">
                  <v-text-field
                    label="Funding offered"
                    v-model="fundingOffered"
                    required
                    prefix="£"
                    :onkeyup="formatCurrency()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 class="pa-3">
                  <v-menu
                    ref="fromMenu"
                    v-model="showDateFundingOffered"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="updates.date_funding_offered"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        placeholder="Date funding offered"
                        v-model="prettyDateFundingOffered"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="updates.date_funding_offered"
                      no-title
                      scrollable
                      min="2016-05-01"
                      :max="new Date().toISOString().substr(0, 10)"
                      @change="$refs.fromMenu.save(updates.date_funding_offered)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="showDateFundingOffered = false">Cancel</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click.native="closeDialog">Close</v-btn>
          <v-btn :disabled="fundingOfferedCheck" color="accent" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';
import { DateTime } from 'luxon';

export default {
  name: 'customer-registration-dialog',
  props: ['show', 'enquiry', 'status_id'],
  data: () => ({
    showDateFundingOffered: false,
    fundingOffered: null,
    updates: {
      funding_offered: 0,
      date_funding_offered: null,
      enquiry_status_id: ''
    }
  }),
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    prettyDateFundingOffered: function() {
      return _.isNull(this.updates.date_funding_offered)
        ? null
        : DateTime.fromISO(this.updates.date_funding_offered).toLocaleString();
    },
    fundingOfferedCheck() {
      return _.isEmpty(this.fundingOffered) || this.fundingOffered < 1 || _.isEmpty(this.updates.date_funding_offered);
    }
  },
  methods: {
    ...mapActions(['storeCustomerEnquiry', 'addNotification']),
    closeDialog() {
      this.dialog = false;
    },
    save() {
      let updates = Object.assign({}, this.updates);
      updates.funding_offered = parseFloat(this.fundingOffered.replace(/[^\d.]/g, ''));
      updates.enquiry_status_id = this.status_id;
      this.storeCustomerEnquiry({
        id: this.enquiry.id,
        updates
      }).then(() => {
        this.addNotification({
          text: `enquiry updated`
        });
        this.dialog = false;
      });
    },
    formatCurrency() {
      let value = this.fundingOffered;
      const intValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d.]/g, '')) : value;

      this.fundingOffered =
        intValue > 0
          ? intValue.toLocaleString({
              style: 'currency',
              currency: 'GBP',
              currencyDisplay: 'symbol',
              minimumSignificantDigits: 0,
              maximumSignificantDigits: 0
            })
          : value;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
